import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';
import { getApostatudoRequestHeaders } from '~/utils/apostatudo/get-apostatudo-request-headers';
import type { ApiFetchCuratedEventsPort } from '~/handlers/ports/api-fetch-curated-events.port';
import type {
  CuratedEvent,
  CuratedEventsApiResponse,
  FetchCuratedEventsParams,
} from '~/types/curated-events';

const ENDPOINT = '/curated-events';

export class ApostatudoApiFetchCuratedEventsAdapter
  implements ApiFetchCuratedEventsPort
{
  async handle(params?: FetchCuratedEventsParams): Promise<CuratedEvent[]> {
    const query = new URLSearchParams();

    if (params?.date) query.set('date', params.date);
    if (params?.limit) query.set('limit', String(params.limit));

    const qs = query.toString();
    const url = `${getApostatudoApiUrl()}${ENDPOINT}${qs ? `?${qs}` : ''}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json', ...getApostatudoRequestHeaders() },
    });

    if (!response.ok) {
      throw new Error(
        `[ApostatudoApiFetchCuratedEventsAdapter] HTTP ${response.status}`,
      );
    }

    const result: CuratedEventsApiResponse = await response.json();

    return (result.data ?? []).flatMap((group) => group.events ?? []);
  }
}
